import * as React from 'react';

import { BaseExercisePage } from '../baseExercisePage';
import ContrastTrackingCanvas from './canvas';
import * as Edge from '../../../core';

import ContrastTrackingResults from './results';
import ContrastTrackingConfigForm from './configForm';

export default class ContrastTrackingPage extends BaseExercisePage<
	Edge.Models.ContrastTrackingExerciseConfiguration,
	Edge.Models.ContrastTrackingExerciseResult
> {
	protected renderConfiguration(): JSX.Element {
		const { lockConfiguration, operationName, mode } = this.props;
		const { configuration } = this.state;

		return (
			<ContrastTrackingConfigForm
				mode={mode}
				operationName={operationName}
				onSubmit={this.startExercise}
				initialConfiguration={configuration}
				lockConfiguration={lockConfiguration}
			/>
		);
	}

	protected renderExercise(): JSX.Element {
		const { currentProfile, mode } = this.props;
		const { configuration, fullScreen } = this.state;

		return (
			<ContrastTrackingCanvas
				mode={mode}
				debugMode={this.props.debugMode}
				renderScale={currentProfile.renderScale}
				touchControls={currentProfile.touchControls}
				fullScreen={fullScreen!}
				completeExercise={this.finishExercise}
				abortingExercise={this.abortingExercise}
				configuration={configuration}
			/>
		);
	}

	protected renderResults(): JSX.Element {
		const { hideExerciseResults } = this.props;

		return (
			<ContrastTrackingResults
				results={this.state.result!}
				complete={this.complete}
				retry={this.retryExercise}
				completeText={this.props.completeText}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
